export const CONSENT_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
};

export const CONSENT_STATUS_MAPPER = {
  [CONSENT_STATUS.ACTIVE]: 'documentation.consent.active',
  [CONSENT_STATUS.EXPIRED]: 'documentation.consent.expired',
  [CONSENT_STATUS.REVOKED]: 'documentation.consent.revoked',
};

export const CONSENT_ASSIGNMENT_TYPE = {
  PAPER_CONSENT: 'PaperConsent',
};



// WEBPACK FOOTER //
// ./src/constants/consentStatus.js